import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TagIcon from '@mui/icons-material/Tag';
import PinterestIcon from '@mui/icons-material/Pinterest';
import LinkIcon from '@mui/icons-material/Link';

// Single source of truth for the social profile links shown/edited across the
// web app. `key` matches the User field on the API. MUI has no dedicated
// TikTok/Threads/Snapchat brand glyph, so those use the closest fallback icon.
export const SOCIAL_PLATFORMS = [
  { key: 'facebookUrl', label: 'Facebook', Icon: FacebookIcon, color: '#1877F2', placeholder: 'https://facebook.com/…' },
  { key: 'instagramUrl', label: 'Instagram', Icon: InstagramIcon, color: '#C13584', placeholder: 'https://instagram.com/…' },
  { key: 'tiktokUrl', label: 'TikTok', Icon: MusicNoteIcon, color: '#ffffff', placeholder: 'https://tiktok.com/@…' },
  { key: 'youtubeUrl', label: 'YouTube', Icon: YouTubeIcon, color: '#FF0000', placeholder: 'https://youtube.com/@…' },
  { key: 'threadsUrl', label: 'Threads', Icon: TagIcon, color: '#ffffff', placeholder: 'https://threads.net/@…' },
  { key: 'pinterestUrl', label: 'Pinterest', Icon: PinterestIcon, color: '#E60023', placeholder: 'https://pinterest.com/…' },
  { key: 'snapchatUrl', label: 'Snapchat', Icon: LinkIcon, color: '#FFFC00', placeholder: 'https://snapchat.com/add/…' },
];
